/* eslint-disable @typescript-eslint/ban-ts-comment */

/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"
import { NeoletterUserProfileFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }
const defaultOptions = {} as const
export type NeoletterUserProfileQueryVariables = Exact<{ [key: string]: never }>

export type NeoletterUserProfileQuery = {
  __typename: "Query"
  neoletterUserProfile?: {
    __typename: "NeoletterUserProfile"
    id: string
    name?: string | null
    salutation?: string | null
    given_name?: string | null
    family_name?: string | null
    email?: string | null
    position?: string | null
    staff?: boolean | null
    phone_number?: string | null
    company?: string | null
    custom_fields?: {
      __typename: "NeoletterUserProfileCustomFields"
      active_project_id?: string | null
      sidebar_is_expanded?: string | null
    } | null
  } | null
}

export const NeoletterUserProfileDocument = gql`
  query NeoletterUserProfile {
    neoletterUserProfile
      @rest(type: "NeoletterUserProfile", endpoint: "userProfile", path: "") {
      ...NeoletterUserProfile
    }
  }
  ${NeoletterUserProfileFragmentDoc}
`

/**
 * __useNeoletterUserProfileQuery__
 *
 * To run a query within a React component, call `useNeoletterUserProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useNeoletterUserProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNeoletterUserProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useNeoletterUserProfileQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NeoletterUserProfileQuery,
    NeoletterUserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    NeoletterUserProfileQuery,
    NeoletterUserProfileQueryVariables
  >(NeoletterUserProfileDocument, options)
}
export function useNeoletterUserProfileLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NeoletterUserProfileQuery,
    NeoletterUserProfileQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NeoletterUserProfileQuery,
    NeoletterUserProfileQueryVariables
  >(NeoletterUserProfileDocument, options)
}
// @ts-ignore
export function useNeoletterUserProfileSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NeoletterUserProfileQuery,
    NeoletterUserProfileQueryVariables
  >
): Apollo.UseSuspenseQueryResult<
  NeoletterUserProfileQuery,
  NeoletterUserProfileQueryVariables
>
export function useNeoletterUserProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NeoletterUserProfileQuery,
        NeoletterUserProfileQueryVariables
      >
): Apollo.UseSuspenseQueryResult<
  NeoletterUserProfileQuery | undefined,
  NeoletterUserProfileQueryVariables
>
export function useNeoletterUserProfileSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        NeoletterUserProfileQuery,
        NeoletterUserProfileQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    NeoletterUserProfileQuery,
    NeoletterUserProfileQueryVariables
  >(NeoletterUserProfileDocument, options)
}
export type NeoletterUserProfileQueryHookResult = ReturnType<
  typeof useNeoletterUserProfileQuery
>
export type NeoletterUserProfileLazyQueryHookResult = ReturnType<
  typeof useNeoletterUserProfileLazyQuery
>
export type NeoletterUserProfileSuspenseQueryHookResult = ReturnType<
  typeof useNeoletterUserProfileSuspenseQuery
>
export type NeoletterUserProfileQueryResult = Apollo.QueryResult<
  NeoletterUserProfileQuery,
  NeoletterUserProfileQueryVariables
>
